import { render } from "./CZAccrualsElectricity.vue?vue&type=template&id=8c2fee86&scoped=true&ts=true"
import script from "./CZAccrualsElectricity.vue?vue&type=script&lang=ts"
export * from "./CZAccrualsElectricity.vue?vue&type=script&lang=ts"

import "./CZAccrualsElectricity.vue?vue&type=style&index=0&id=8c2fee86&scoped=true&lang=css"

import exportComponent from "C:\\Devlop\\C-Zone-v1\\UI_EICPartnership\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c2fee86"]])

export default __exports__